export const name = 'environmentService' as const
